import { render, staticRenderFns } from "./PccNoteSender.vue?vue&type=template&id=20834632&"
import script from "./PccNoteSender.vue?vue&type=script&lang=js&"
export * from "./PccNoteSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports